'use client';

import { AccountMenu } from '@/app_components/header/AccountMenu';
import { SignInButton } from '@/app_components/header/SignInButton';
import { SubscribeButton } from '@/app_components/header/SubscribeButton';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { useUser } from '@/app_lib/providers/UserProvider';
import { cn } from '@/app_lib/utils/utils';

export const AuthMenu = () => {
  const { pianoLoadingState, userAccess } = useUser();
  const { loggedIn, hasAccess } = userAccess;
  const loading = pianoLoadingState !== 'loaded' || loggedIn === undefined;

  const content = (
    <div className='flex gap-4 lg:gap-6'>
      {/* Show subscribed button if not logged in or they don't have a subscription */}
      {!(loggedIn && hasAccess) && (
        <div className={cn(loggedIn && 'hidden md:inline-block')}>
          <SubscribeButton>
            <span className='md:hidden'>Subscribe</span>
            <span className='hidden md:inline'>Subscribe Now</span>
          </SubscribeButton>
        </div>
      )}
      {loggedIn ? <AccountMenu /> : <SignInButton className='hidden md:inline-block' />}
    </div>
  );

  return loading ? (
    <ButtonV2
      as='button'
      className='w-[113px] md:w-[280px] bg-helper! animate-pulse rounded-full'
    >
      <span className='invisible'>Subscribe</span>
    </ButtonV2>
  ) : (
    content
  );
};
